// src/services/api.js
import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api'
});

// Intercepta a REQUEST → adiciona token
api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Intercepta a RESPONSE → verifica se token expirou
api.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            // Se for erro 401 (Token inválido ou expirado)
            const currentPath = window.location.pathname;
            if (currentPath !== '/login') {
                // ✅ sem mensagem, só limpa e volta pro login
                //alert('Sua sessão expirou. Faça login novamente.');
                localStorage.removeItem('token');
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
